// extracted by mini-css-extract-plugin
export default {"textBlock":"TextBlock_textBlock__9gdQ9","textBlock_title":"TextBlock_textBlock_title__osXPq","textBlock_text":"TextBlock_textBlock_text__qpOD9"};